module.exports = __webpack_public_path__ + "static/assets/2dda78968aae655c392d15281578a682.gif";